export const updateLimitedPointsOnLine = (apiClient) => {
    return {
        build(params) {
            return apiClient.request('/standard/updateLimitedPointsOnLine', params);
        },
    };
};
